/**
 * Auth translations: auth, register, verifyEmail
 */

export const auth = {
  login: 'Anmelden',
  logout: 'Abmelden',
  register: 'Registrieren',
  welcome: 'Willkommen zurück',
  loginPrompt: 'Melde dich in deinem Konto an',
  noAccount: 'Noch kein Konto?',
  registerNow: 'Jetzt registrieren',
  alreadyHaveAccount: 'Bereits ein Konto?',
  loginNow: 'Jetzt anmelden',
  email: 'E-Mail-Adresse',
  emailPlaceholder: "name{'@'}beispiel.de",
  password: 'Passwort',
  passwordPlaceholder: '••••••••',
  showPassword: 'Passwort anzeigen',
  hidePassword: 'Passwort verbergen',
  confirmCode: 'Bestätigungscode',
  otpHint: 'Gib den Code aus deiner Authenticator-App oder E-Mail ein',
  otpPlaceholder: '123456',
  confirm: 'Bestätigen',
  loginSuccess: 'Du wurdest erfolgreich angemeldet.',
  loginFailed: 'Anmeldung fehlgeschlagen',
  wrongCredentials: 'E-Mail oder Passwort ist falsch.',
  tooManyAttempts: 'Zu viele Anmeldeversuche. Bitte warte einen Moment.',
  sessionExpired: 'Sitzung abgelaufen',
  sessionExpiredMessage: 'Bitte melde dich erneut an.',
  verificationFailed: 'Verifizierung fehlgeschlagen',
  otpInvalid: 'Der Bestätigungscode ist ungültig oder abgelaufen.',
  createAccount: 'Konto erstellen',
  registerPrompt: 'Registriere dich für deinen Zugang',
  registerStep1: 'Persönliche Daten',
  registerStep2: 'Zugangsdaten',
  registerSuccess: 'Dein Konto wurde erfolgreich erstellt.',
  registerFailed: 'Registrierung fehlgeschlagen',
  emailAlreadyExists: 'Diese E-Mail-Adresse ist bereits registriert.',
  captchaFailed: 'Captcha-Verifizierung fehlgeschlagen. Bitte versuche es erneut.',
  turnstileError: 'Die Verifizierung konnte nicht geladen werden. Passiert das wieder, erlaube challenges.cloudflare.com in deinem Werbe- oder Trackingblocker.',
  turnstileErrorCode: 'Fehlercode: {code}',
  turnstileRetry: 'Erneut versuchen',
  invalidInput: 'Ungültige Eingabe. Bitte überprüfe deine Daten.',
  forgotPassword: 'Passwort vergessen?',
  forgotPasswordTitle: 'Passwort zurücksetzen',
  forgotPasswordPrompt:
    'Gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen deines Passworts zu erhalten.',
  sendResetLink: 'Link senden',
  resetLinkSent: 'Link gesendet',
  resetLinkSentMessage:
    'Falls ein Konto mit dieser E-Mail existiert, erhältst du in Kürze eine E-Mail mit Anweisungen zum Zurücksetzen deines Passworts.',
  backToLogin: 'Zurück zur Anmeldung',
  resetPasswordTitle: 'Neues Passwort festlegen',
  resetPasswordPrompt: 'Gib dein neues Passwort ein.',
  newPassword: 'Neues Passwort',
  confirmNewPassword: 'Passwort bestätigen',
  resetPassword: 'Passwort zurücksetzen',
  passwordResetSuccess: 'Passwort erfolgreich geändert',
  passwordResetSuccessMessage:
    'Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.',
  passwordResetFailed: 'Passwort zurücksetzen fehlgeschlagen',
  invalidResetToken: 'Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.',
  passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein.',
  noResetToken: 'Kein Token gefunden. Bitte öffne den Link aus der E-Mail.',
  requestNewLink: 'Neuen Link anfordern'
} as const

export const register = {
  accountType: {
    person: 'Privatperson',
    organization: 'Firma'
  },
  fields: {
    orgName: 'Firmenname inkl. Rechtsform',
    vatId: 'Umsatzsteuer-IdNr. (optional)',
    vatIdHint: 'Wir prüfen die Nummer im VIES-System der EU-Kommission. Eine deutsche Nummer prüfen wir nur auf Gültigkeit. Bei einer Nummer aus einem anderen EU-Land übermitteln wir auch deinen Firmennamen und deine Rechnungsanschrift an die Steuerverwaltung dieses Landes; ist sie bestätigt, zahlst du Nettopreise ohne deutsche Umsatzsteuer. Details in der Datenschutzerklärung.',
    firstName: 'Vorname',
    lastName: 'Nachname',
    street: 'Straße und Hausnummer',
    addressLine2: 'Adresszusatz (optional)',
    country: 'Land',
    postcode: 'PLZ',
    state: 'Bundesland / Region',
    city: 'Ort',
    phonePrefix: 'Vorwahl',
    phone: 'Mobilfunknummer',
    email: 'E-Mail-Adresse',
    emailPlaceholder: "name{'@'}beispiel.de",
    emailHint: 'Diese E-Mail wird für die Anmeldung und Kommunikation verwendet',
    password: 'Passwort erstellen',
    passwordPlaceholder: 'Sicheres Passwort wählen'
  },
  sections: {
    personal: 'Persönliche Daten',
    address: 'Adresse',
    contact: 'Kontakt'
  },
  buttons: {
    next: 'Weiter',
    back: 'Zurück zu Schritt 1',
    createAccount: 'Konto erstellen'
  },
  errors: {
    passwordTooWeak: 'Passwort zu schwach',
    passwordTooWeakMessage: 'Bitte wähle ein stärkeres Passwort mit Groß-/Kleinbuchstaben und Zahlen.',
    invalidInput: 'Eingabe ungültig',
    checkInputs: 'Bitte überprüfe deine Eingaben.',
    captchaRequired: 'Captcha-Verifizierung erforderlich. Bitte lade die Seite neu und versuche es erneut.',
    invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    invalidPassword: 'Das Passwort muss mindestens 8 Zeichen, Groß-/Kleinbuchstaben und eine Zahl enthalten.',
    passwordComplexity: 'Passwort muss Groß-/Kleinbuchstaben und mindestens eine Zahl enthalten'
  },
  terms: {
    prefix: 'Mit der Registrierung akzeptierst du unsere',
    agb: 'AGB',
    and: 'und',
    privacy: 'Datenschutzerklärung'
  }
} as const

export const verifyEmail = {
  loading: {
    title: 'E-Mail wird verifiziert...',
    description: 'Bitte warte einen Moment.'
  },
  success: {
    title: 'E-Mail verifiziert!',
    description: 'Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du hast jetzt Zugriff auf alle Funktionen.',
    goToDashboard: 'Zum Dashboard'
  },
  alreadyVerified: {
    title: 'Bereits verifiziert',
    description: 'Deine E-Mail-Adresse wurde bereits verifiziert.',
    goToDashboard: 'Zum Dashboard'
  },
  error: {
    title: 'Verifizierung fehlgeschlagen',
    goToLogin: 'Zum Login',
    goToDashboard: 'Zum Dashboard'
  },
  errors: {
    noToken: 'Kein Verifizierungstoken gefunden. Bitte öffne den Link aus der E-Mail erneut.',
    notLoggedIn: 'Du musst angemeldet sein, um deine E-Mail zu verifizieren. Bitte melde dich an und klicke dann erneut auf den Link.',
    invalidToken: 'Der Verifizierungslink ist ungültig oder abgelaufen. Bitte fordere eine neue Verifizierungs-E-Mail an.',
    generic: 'Bei der Verifizierung ist ein Fehler aufgetreten. Bitte versuche es später erneut.'
  }
} as const
